module.exports = __webpack_public_path__ + "static/media/gc-journey.362c98c5.png";